






import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

interface Insertion {
    advertisingSpace: {
        broadcastStartDate: string,
    };
}

@Component({ components: { } })
export default class BroadcastDate extends Vue {
    @Prop() public insertion!: Insertion;

    public static getNeededFields(): string[] {
        return [
            "advertisingSpace.broadcastStartDate",
        ];
    }
}
